import { ColumnOptions } from '../types/column-options';
import { NumberColumn } from '../types/grid';
import { ColumnHostRef } from '../types/refs';

export interface NumberColumnOptions<TRow extends object> extends ColumnOptions<TRow, number> {
  format?: string;
  rowGroup?: boolean;
  aggFunc?: string;
  pivot?: boolean;
  preventNumberDefault?: boolean;
}

export function numberColumn<TRow extends object>(ref: ColumnHostRef<TRow>,
                                                  options: NumberColumnOptions<TRow>): NumberColumn<TRow> {
  const column: NumberColumn<TRow> = {
    ...options,
    type: 'number',
    format: options.format ?? 'NUMBER.DEFAULT'
  }
  ref.createColumn(column);
  return column;
}
